<template>
  <main>
    <Header :loginSource="loginSource"></Header>

    <section v-if="courseWrapper.course" class="merchant_container">
<!--      <img v-if="buyed" class="wxgroup_img" src="/static/images/wxgroup.png" >-->
      <img class="wxgroup_img" src="/static/images/wxgroup.png" >

      <div class="merchant_wrapper">
        <div class="order_title">
          <el-breadcrumb separator-class="el-icon-arrow-right">
<!--            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
            <el-breadcrumb-item>BigData On K8s</el-breadcrumb-item>
            <el-breadcrumb-item>{{courseWrapper.course.name}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <hr>
        <div class="merchant_block">
          <div class="merchant_content">
            <div>
              <img class="storefront_image" :src="courseWrapper.course.coverPic" >
              <p class="play_tips" v-if="courseWrapper.course.realPrice > 99"><i class="el-icon-info"></i> 所有付费课程视频均是2K超清画质。</p>
              <p class="play_tips" v-if="courseWrapper.course.realPrice > 99"><i class="el-icon-info"></i> 付费用户可以观看本课程后续所有更新/新增视频。</p>
<!--              <p class="play_tips" v-if="courseWrapper.course.realPrice > 99"><i class="el-icon-info"></i> 付费用户可以扫码进群技术交流。</p>-->
<!--              <p class="play_tips" v-if="courseWrapper.course.realPrice < 100"><i class="el-icon-info"></i> 费用用于支付网站云资源费用。</p>-->

            </div>

            <div class="merchant_desc">
              <div style="display: flex; flex-direction: row">
                <div v-if="courseWrapper.course.realPrice < 90000" class="merchant_name">{{courseWrapper.course.name}}</div>
                <div v-else class="merchant_name">{{courseWrapper.course.name}}（更新中）</div>
                <div style="margin-left: 12px; font-size: 14px; color: #999; font-weight: normal;" v-if="courseWrapper.course.realPrice < 90000 && courseWrapper.course.statistics.buyTimes > 49">
                  <span><i class="el-icon-shopping-cart-2"></i> {{courseWrapper.course.statistics.buyTimes}}</span>&nbsp;
                  <span><i class="el-icon-video-play"></i> {{courseWrapper.course.statistics.viewTimes}}</span>
                </div>
              </div>

              <div class="merchant_item">{{courseWrapper.course.shortDesc}}</div>
              <div class="merchant_higher_price" v-if="courseWrapper.course.realPrice > 99">课程原价：￥{{courseWrapper.course.originalPrice}}</div>
<!--              <div class="merchant_lower_price" v-if="courseWrapper.course.realPrice < 90000" >限时优惠：￥{{courseWrapper.course.realPrice}}</div>-->
<!--              <div class="merchant_lower_price" v-else>限时优惠：价格待定</div>-->

              <div class="merchant_lower_price" v-if="courseWrapper.course.realPrice < 90000">{{courseWrapper.course.realPrice < 100 ? '内部专享' : '限时优惠'}}：￥{{courseWrapper.course.realPrice}}</div>
              <div class="merchant_lower_price" v-else>限时优惠：价格待定</div>

<!--              <p class="play_tips"><i class="el-icon-info"></i> 所有付费课程视频均是2K超清画质。</p>-->
<!--              <p class="play_tips"><i class="el-icon-info"></i> 付费用户可以观看本课程后续所有更新/新增视频。</p>-->
            </div>
            <el-button class="search_button" type="primary" icon="el-icon-shopping-cart-2" :disabled="courseWrapper.course.realPrice > 90000" @click="buyCourse(no)">购买课程</el-button>
          </div>
          <hr>
        </div>
      </div>
    </section>

    <section class="merchant_container">
      <el-tabs class="tabs_wrapper" v-model="activeName">
        <el-tab-pane label="课程介绍" name="first">
          <div class="merchant_wrapper" v-if="courseWrapper.course">
            <p style="color: #666; font-size: 20px;" class="course_desc" v-if="courseWrapper.course.realPrice > 90000">课程更新中，即将上线</p>
            <p class="course_desc" v-html="courseWrapper.course.longDesc"></p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="课程大纲" name="second">
          <div class="merchant_wrapper" v-if="courseWrapper.course">
            <el-image
              v-if="courseWrapper.course.outlinePic"
              :src="courseWrapper.course.outlinePic"
              :preview-src-list="courseWrapper.course.outlinePics">
            </el-image>
            <br>
          </div>
        </el-tab-pane>
        <el-tab-pane label="课程视频" name="third">
          <div class="merchant_wrapper">
            <div class="merchant_block">
              <el-table
                :data="courseWrapper.videos"
                @row-click="playCourse"
                style="width: 100%">
                <el-table-column
                  prop="tag"
                  label=""
                  width="78">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.charge === 0" type="success" disable-transitions>免费</el-tag>
                    <el-tag v-if="scope.row.charge === 1 && !buyed" type="danger" disable-transitions>付费</el-tag>
                    <el-tag v-if="scope.row.charge === 1 && buyed" type="danger" disable-transitions>已付费</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="">
                </el-table-column>
                <el-table-column
                  label=""
                  align="right"
                  width="90">
                  <template slot-scope="scope">
                    {{scope.row.durationStr}} <i class="el-icon-video-play"></i>
                  </template>
                </el-table-column>
              </el-table>

            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="课程笔记" name="fourth">
          <div class="merchant_wrapper" v-if="courseWrapper.course">
            <p style="color: #666; font-size: 20px;" class="course_desc" v-if="courseWrapper.course.realPrice > 90000">课程更新中，即将上线</p>

            <div class="merchant_block">
              <el-table
                :data="courseWrapper.materials"
                @row-click="openMaterial"
                style="width: 100%">
                <el-table-column
                  prop="tag"
                  label=""
                  width="78">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.charge === 0" type="success" disable-transitions>免费</el-tag>
                    <el-tag v-if="scope.row.charge === 1 && !buyed" type="danger" disable-transitions>付费</el-tag>
                    <el-tag v-if="scope.row.charge === 1 && buyed" type="danger" disable-transitions>已付费</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="">
                </el-table-column>
              </el-table>

            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="课程资料" name="five">
          <div class="merchant_wrapper" v-if="courseWrapper.datums">
            <div class="merchant_block" style="margin-bottom: 60px;">
              <div>
                <p>K8s非高可用集群安装指引</p>
                <a href="/static/docs/k8s-noha.txt" target="_blank">K8s非高可用集群安装指引</a>
                <br>
                <br>

                <p>知乎专栏</p>
                <a href="https://www.zhihu.com/people/0700360208" target="_blank">Bigdata On K8s实践系列文章</a>
                <br>

                <p>CSDN专栏</p>
                <a href="https://blog.csdn.net/homeofcm?type=blog" target="_blank">Bigdata On K8s实践系列文章</a>
                <br>
              </div>

              <br>
              <div v-for="(item, index) in courseWrapper.datums" :key="index" >
                <h4>{{item.name}}</h4>
                <template v-if="item.charge === 0">
                  <p v-if="item.type === 'txt'">{{item.content}}</p>
                  <a v-if="item.type === 'link'" :href="item.url" :download="item.content">{{item.content}}</a>
                </template>
                <template v-else>
                  <template v-if="buyed">
                    <p v-if="item.type === 'txt'">{{item.content}}</p>
                    <a v-if="item.type === 'link'" :href="item.url" :download="item.content">{{item.content}}</a>
                  </template>
                  <template v-else>
                    <p style="color: #999;">购买课程后显示</p>
                  </template>
                </template>
                <br>
              </div>

            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

    </section>

    <Footer></Footer>
  </main>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import {mapGetters, mapState} from 'vuex'
import {
  reqFindCourseVideos,
  reqCheckBuyCourse,
  reqAddMaterialClickHistory
} from '@/api'

export default {
  name: 'Course',
  components: {Header, Footer},
  comments: {
    Header
  },

  data() {
    return {
      no: parseInt(this.$route.query.no), // 课程编号
      loginSource: 2*1000 + parseInt(this.$route.query.no),
      activeName: this.$route.query.activeName ? this.$route.query.activeName : 'third',
      courseWrapper: {},
      buyed: false
    }
  },

  async mounted () {
    if (!this.no) {
      await this.$router.push('/index')
    }

    const loading = this.$loading({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    await this.getCourseVideos()
    if (this.isLogin) {
      await this.checkBuyCourse()
    }

    loading.close()
  },

  methods: {

    buyCourse (index) {
      this.$router.push({
        path: '/orderConfirm',
        query: {no: this.no}
      }).catch(err=>{})
    },

    playCourse (row, column, event) {
      if (!this.isLogin) {
        this.$message({
          message: '请先登录',
          type: 'error'
        })
        return
      }

      if (row.charge && !this.buyed) {
        this.$alert('课程未购买，请购买后再播放', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        return
      }

      // 要加上catch语句，要不然会因为没有登录无法跳转到/playCourse 从而导致push报错
      this.$router.push({
        path: '/playCourse',
        query: {no: this.no, videoNo: row.videoNo}
      }).catch(err=>{})

    },

    // 检查是否购买了课程
    async checkBuyCourse () {
      const result = await reqCheckBuyCourse(this.no)
      // 购买了课程
      if (result.code === 0) {
        this.buyed = true
      }
    },

    async openMaterial (row, column, event) {
      // if (row.charge) {
      //   const result = await reqCheckBuyCourse(this.no)
      //   // 资料需要付费，但未购买课程
      //   if (result.code) {
      //     await this.$alert('课程未购买，请购买后再查看', '提示', {
      //       confirmButtonText: '确定',
      //       callback: action => {
      //       }
      //     })
      //     return
      //   }
      // }

      if (!this.isLogin) {
        this.$message({
          message: '请先登录',
          type: 'error'
        })
        return
      }

      if (row.charge && !this.buyed) {
        this.$alert('课程未购买，请购买后再查看', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
        return
      }

      if (row.type === 'html') {
        // 打开新的页面
        let {href} = this.$router.resolve(
          {
            path: '/material',
            query: {
              no: this.no,
              id: row.id
            }
          }
        )
        window.open(href, '_blank')
      } else {
        if (!this.isLogin) {
          this.$router.push('/login')
          return
        }
        await reqAddMaterialClickHistory(row.no, parseInt(row.id))
        let {href} = this.$router.resolve(
          {
            path: row.url
          }
        )
        window.open(href, '_blank')
      }

    },

    async getCourseVideos () {
      const result = await reqFindCourseVideos(this.no)
      if (result.code === 0) {
        this.courseWrapper = result.data
        const courseWrapper = this.courseWrapper
        await this.$store.dispatch('setCourseWrapper', {courseWrapper})
      }
    },

  },

  computed: {
    ...mapGetters(['isLogin']),
  }

}
</script>

<style scoped>

  main {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .logo_search_container {
    display: flex;
    width: 100%;
    margin: 0px auto;
  }

  .logo_search_container > img {
    width: 1000px;
    /*width: 65vw;*/
    height: 500px;
    margin: auto;
  }

  .merchant_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    /*background: #eee;*/
  }

  .tabs_wrapper {
    width: 1000px;
    /*width: 960px;*/
    /*width: 65vw;*/
    margin: 0px auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    /*padding: 0 20px;*/
  }

  .merchant_wrapper {
    width: 1000px;
    /*width: 960px;*/
    /*width: 65vw;*/
    margin: 0px auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    /*padding: 0 20px;*/
  }

  .order_title {
    /*line-height: 40px;*/
    margin-top: 20px;
    font-size: 18px;
    font-weight: 500;
  }

  hr {
    border: 1px solid #eee;
    width: 100%;
    margin: 20px 0;
  }

  .merchant_content {
    display: flex;
  }

  .storefront_image {
    width: 320px;
    height: 260px;
    border-radius: 6px;
    margin-right: 20px;
    cursor: pointer;
    border: 1px solid;
  }

  .merchant_desc {
    display: flex;
    flex-direction: column;
  }

  .merchant_name {
    cursor: pointer;
  }

  .merchant_desc div:first-child {
    font-size: 24px;
    color: #000;
    font-weight: bold;
  }

  .merchant_desc div {
    line-height: 30px;
    /*font-size: 14px;*/
    /*color: #999;*/
  }

  .course_desc {
    font-size: 16px;
    line-height: 30px;
    color: #333;
  }

  .merchant_item {
    font-size: 14px;
    color: #333;
  }

  .merchant_higher_price {
    font-size: 16px;
    color: #999;
    text-decoration:line-through;
  }

  .merchant_lower_price {
    font-size: 18px;
    color: #CC0033;
    font-weight: bold;
  }

  .wxgroup_img {
    position: fixed;
    top: 100px;
    right: 50px;
    width: 170px;
    height: 210px;
  }

  .search_button {
    margin-left: 30px;
    height: 40px;
  }

  .play_tips {
    font-size: 12px;
    color: #999;
  }

  /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
    background: #99CCFF !important;
    cursor:pointer !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Course/Course.vue